import styled from "styled-components";

export const LayoutConainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  header{
    width: 100%;
    background-color: white;
    position: fixed;
    top: 0;
    z-index: 10;
    .logo{
      img{
        width: 100%;
      }
    }

    .mobile_menu{
      padding: 0;
      background-color: transparent;
      border: none;
    }

    .right{
      strong{
        font-size: 16px;
      }

      button, a{
        padding: 10px;
        transition: color .2s;
        &:hover{
          color: var(--main);
        }
      }

      button{
        border: none;
        background-color: transparent;
      }

      .contact_btn_group{
        button, a{
          margin-right: 20px;
        }
      }

      .area_myinfo{
        position: relative;
        .btn_id{
          .ic{
            width: 12px;
            height: 12px;
            margin-left: 6px;
            background-color: #222;
            mask: url(/images/arrow_down.png) no-repeat center center / 12px 12px;
          }

          &:hover{
            .ic{
              background-color: var(--main);
              transition: all .2s;
            }
          }

          &.open .ic{
            transform: rotate(180deg);
          }
        }

        /* .card{
          border: 1px solid var(--gray_e);
          border-radius: 12px;
          overflow: hidden;
          position: absolute;
          left: 0;
          button, a{
            padding: 12px 24px;
            white-space: nowrap;
            transition: all .2s;

            &:hover{
              background-color: var(--light_green);
            }
          }
        } */
      }
    }
  }
  
  footer{
    margin-top: auto;
    padding: 48px 0 30px;
    background-color: var(--main);
    color: white;
    .top{
      .left{
        width: 120px;
        height: 25px;
        background: url(/images/logo_footer.png) no-repeat center center / cover;
      }

      .right{
        button{
          border: none;
          background-color: transparent;
          color: white;
        }
      }
    }

    .bottom{
      p{
        + p:not(.fs12){
          margin-top: 2px;
        }
        &.fs12{
          margin-top: 40px;
        }
      }
    }
  }

  @media screen and (min-width: 501px) {
    min-width: 1200px;

    header{
      height: 80px;
      .inner{
        justify-content: space-between;
        .logo{
          width: 160px;
          height: 39px;
        }

        .right{
          .btn_signin, .btn_id{ margin-right: -10px; }
          .area_myinfo{
            .card{
              border: 1px solid var(--gray_e);
              border-radius: 12px;
              overflow: hidden;
              position: absolute;
              left: 0;
              button, a{
                padding: 12px 24px;
                white-space: nowrap;
                transition: all .2s;

                &:hover{
                  background-color: var(--light_green);
                }
              }
            }
          }
        }
      }
    }

    footer{
      .top{
        margin-bottom: 70px;
        align-items: center;
        justify-content: space-between;
        .right{
          button{
            padding: 0 10px;
            + button{
              margin-left: 40px;
            }

            strong{
              font-size: 18px;
            }
          }
        }
      }

      .bottom{
        p, span{
          line-height: 22px;
        }
        span + span, .mobile + span{
          display: inline-block;
          margin-left: 12px;
          position: relative;
          &::before{
            content: '';
            width: 1px;
            height: 60%;
            background-color: white;
            position: absolute;
            top: 50%;
            left: -6px;
            transform: translate(50%, -50%);
          }
        }
        br.mobile{
          display: none;
        }
      }
    }
  }
  
  @media (max-width: 500px) {
    min-width: 360px;
    
    header{
      height: 60px;
      .inner{
        justify-content: center;
        .logo{
          width: 123px;
          height: 30px;
          img{
            height: 30px;
          }
        }

        .mobile_menu{
          width: 40px;
          height: 40px;
          border: none;
          background: url(images/mobile_menu.png) no-repeat center center / 20px 20px;
          position: absolute;
          top: 10px;
          left: 10px;
        }

        .right{
          width: 100%;
          height: calc(100vh - 60px);
          background-color: white;
          flex-direction: column-reverse;
          justify-content: flex-end;
          position: absolute;
          top: 60px;
          left: 0;

          &:not(.show){
            display: none;
          }
          &.show{
            display: flex;
          }

          .btn_signin{
            padding: 20px;
          }
          .area_myinfo{
            .btn_id{
              width: 100%;
              padding: 20px 20px 8px;
              text-align: left;
              .ic{
                display: none;
              }
            }

            .card{
              margin: 0 0 8px;
              box-shadow: none;
              button, a{
                width: 100%;
                padding: 12px 36px;
                text-align: left;
              }
            }
          }
          
          .contact_btn_group{
            display: block;
          }
          button{
            width: 100%;
            padding: 20px;
            text-align: left;
          }
        }
      }
    }

    footer{
      .top{
        margin-bottom: 45px;
        flex-direction: column;
        .right{
          margin-top: 35px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          button{
            margin-top: 10px;
            padding: 5px 0;
            strong{
              font-size: 16px;
            }
          }
        }
      }

      .bottom{
        p, span{
          line-height: 19px;
          &:not(.fs12){
            font-size: 13px;
          }
        }
        br{
          &.web{
            display: none;
          }
          &:not(.web)+ span + span, &.web + span{
            margin-left: 12px;
            position: relative;
            &::before{
              content: '';
              width: 1px;
              background-color: white;
              position: absolute;
              top: 0;
              left: -6px;
            }
          }

          &:not(.web)+ span + span{
            &::before{
              height: 40%;
              transform: translate(50%, 5%);
            }
          }

          &.web + span{
            &::before{
              height: 100%;
              transform: translate(50%, 2%);
            }
          }
        }
      }
    }
  }
`